export default __webpack_public_path__ + "static/media/bestSmiley.2a765cc1.svg";